import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons/faTimesCircle";
import { faFilter } from "@fortawesome/pro-regular-svg-icons";
import { faArrowDown } from "@fortawesome/pro-solid-svg-icons/faArrowDown";
import { faArrowUp } from "@fortawesome/pro-solid-svg-icons/faArrowUp";

import { Card, CardBody } from 'Components/Partials/Card';
import { Button, InputField } from 'Components/Partials/Form';

/**
 * @clasdsdesc Searchbar Slot
 */
export default class SearchBar extends React.Component {
    /**
     * @var state
     */
    state = {
        value: this.props.value ?? ''
    };

    /**
     * @var timeout
     * @type {null}
     */
    timeout = null;

    /**
     * @method componentDidUpdate
     * @param {object} prevProps
     */
    componentDidUpdate = (prevProps) => {
        if (prevProps.value !== this.props.value) {
            window.clearTimeout(this.timeout);
            this.setState({
                value: this.props.value ?? '',
            });
        }
    };

    /**
     * @method handleChange
     * @param e
     */
    handleChange = (e) => {
        if (e === null) {
            this.setState({ value: null });

            window.clearTimeout(this.timeout);

            // Friction to reduce API request
            this.props.onChange(null, this.props.field);

            return;
        }

        this.setState({
            value: e.target.value,
        });

        window.clearTimeout(this.timeout);

        // Friction to reduce API request
        this.timeout = setTimeout(() => {
            this.props.onChange(this.state.value, this.props.field);
        }, 500); // Calculated on 50 words per minute, with 6 letters per
    };

    /**
     * @method handleFilter
     * @param {object} option
     */
    handleFilter = (option) => {
        this.props.onFilter(option);
    };

    /**
     * @method renderInput
     * @return {*}
     */
    renderInput = () => {
        const { value } = this.state;
        const { showMoreFilters, toggleMoreFilters, moreFilters, disabled, children } = this.props;

        return (
            <div className="space-y-4">
                <div className="flex items-end space-x-4">
                    <div className="flex-1">
                        {children ?? (
                            <InputField
                                onChange={this.handleChange}
                                value={value}
                                placeholder={this.props.placeholder}
                                disabled={disabled}
                                canReset={true}
                            />
                        )}
                    </div>

                    {toggleMoreFilters && (
                        <Button onClick={toggleMoreFilters} className="space-x-6 py-2">
                            <FontAwesomeIcon icon={faFilter} />
                            <FontAwesomeIcon icon={showMoreFilters ? faArrowUp : faArrowDown} />
                        </Button>
                    )}
                </div>

                {showMoreFilters && moreFilters}
            </div>
        );
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {isolated} = this.props;

        if (isolated !== undefined && !isolated) {
            return this.renderInput();
        }

        return (
            <Card className="mb-4">
                <CardBody>
                    {this.renderInput()}
                </CardBody>
            </Card>
        );
    };
}
